import { readManifestFile } from '../../../lib/groupTransfers/workbook';
import { inviteeFromWorkbookRow } from '../../../lib/events/foundation';

// Staff app only (the client app reads CSV): the Group Transfers workbook parser, reused for invitees and programs.
export async function workbookInvitees(file) {
    const parsed = await readManifestFile(file, {});
    return parsed.events.flatMap((ev) => ev.rows.filter((r) => r.name).map(inviteeFromWorkbookRow));
}

export async function readProgramWorkbook(file) {
    const parsed = await readManifestFile(file, {});
    return {
        warnings: parsed.warnings,
        year: parsed.events.find((e) => e.year)?.year || null,
        events: parsed.events.map((ev) => ({
            name: ev.name, title: ev.title || ev.name, start_date: ev.start_date || '', end_date: ev.end_date || ev.start_date || '', host: ev.host || '',
            hotel: ev.hotel || '', hotel_address: ev.hotel_address || '', counts: ev.counts || {}, warnings: ev.warnings || [], selected: true,
            kit_key: 'training_class', invitees: ev.rows.filter((r) => r.name).map(inviteeFromWorkbookRow),
        })),
    };
}
